<template>
    <div
      :class="themeClass"
      style="position: relative; width: 100%; height: auto;"
    >
      <ag-grid-vue
        style="width: 100%; height: 500px"
        ref="agGrid"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :gridOptions="gridOptions"
        :defaultColDef="defaultColDef"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        @columnVisible="onColumnChanged"
        @columnResized="onColumnChanged"
        @columnMoved="onColumnChanged"
        @sort-changed="onSortChanged"
      >
      </ag-grid-vue>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "AgGridTable",
  components: {
    AgGridVue
  },
  props: {
    columnDefs: {
      type: Array
    },
    rowData: {
      type: Array,
      required: true
    },
    gridOptions: {
      type: Object,
      default: () => ({})
    },
    columnVisibility: {
      type: Object,
      default: () => ({})
    },
    defaultColumnPrefs: {
      type: Array,
      default: () => []
    },
    forceLightTheme: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      this.applyColumnState(this.defaultColumnPrefs);
      this.updateColumnsList();
    },
    onFirstDataRendered() {
      this.applyColumnState(this.defaultColumnPrefs);
    },

    onColumnChanged(event) {
      if (this.isApplyingColumnState || (event && event.finished === false)) {
        return;
      }

      this.emitColumnState();
    },
    emitColumnState() {
      if (this.gridColumnApi) {
        const fullState = this.gridColumnApi.getColumnState();
        const minimalState = fullState.map((s, index) => ({
          colId: s.colId,
          width: s.width,
          hide: s.hide
        }));
        this.$emit("column-state-changed", minimalState);
      }
    },
    applyColumnState(stateArray) {
      if (this.gridColumnApi && stateArray && stateArray.length) {
        this.isApplyingColumnState = true;

        try {
          this.gridColumnApi.applyColumnState({
            state: stateArray,
            applyOrder: true
          });
        } finally {
          this.$nextTick(() => {
            this.isApplyingColumnState = false;
          });
        }
      }
    },
    updateColumnsList() {
      if (this.gridColumnApi) {
        const columnsState = this.gridColumnApi.getColumnState();
        this.columnsList = columnsState.map(state => {
          const colDef =
            this.columnDefs.find(def => def.field === state.colId) || {};

          return {
            colId: state.colId,
            headerName: colDef.headerName || state.colId,
            visible: !state.hide
          };
        });
      }
    },
    onSortChanged(params) {
      const sortColumn = params.api.columnModel.gridColumns.filter(column => column.sort != null);
      this.$emit('sort-changed', sortColumn);
    }
  },
  data() {
    return {
      defaultColDef: {
        sortable: false,
        filter: false,
        resizable: true
      },
      columnsList: [],
      isApplyingColumnState: false
    };
  },
  computed: {
    themeClass() {
      if(!this.forceLightTheme) {
        return this.$store.state.darkmode
          ? "ag-theme-alpine-dark"
          : "ag-theme-alpine";
      } else  {
        return "ag-theme-alpine"
      }
    }
  },
  watch: {
    defaultColumnPrefs: {
      deep: true,
      handler(newPreferences) {
        this.applyColumnState(newPreferences);
      }
    }
  }
};
</script>

<style>
.ag-theme-alpine-dark .ag-root,
.ag-theme-alpine-dark .ag-root-wrapper,
.ag-theme-alpine-dark .ag-row,
.ag-theme-alpine-dark .ag-cell,
.ag-theme-alpine-dark .ag-header-cell,
.ag-theme-alpine-dark .ag-header-cell-label {
  background-color: #1e1e2f !important;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  border: none !important;
}

/* MODO CLARO */
.ag-theme-alpine .ag-root,
.ag-theme-alpine .ag-root-wrapper,
.ag-theme-alpine .ag-row,
.ag-theme-alpine .ag-cell,
.ag-theme-alpine .ag-header-cell,
.ag-theme-alpine .ag-header-cell-label {
  background-color: #f5f6fa !important;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  border: none !important;
}

.ag-cell {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}
</style>
